// Nav-Logo-Animation: Buchstaben-Aufstieg beim Laden + periodischer Platin-Sheen
(function(){
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('nav .logo').forEach(function(el){
    var t = el.textContent;
    el.textContent = '';
    el.classList.add('logoanim');
    var i = 0;
    for (var c of t) {
      var s = document.createElement('span');
      s.className = 'lg';
      if (c === ' ' || c === ' ') { s.innerHTML = '&nbsp;'; }
      else { s.textContent = c; }
      s.style.animationDelay = (0.05 + i * 0.035) + 's';
      el.appendChild(s);
      i++;
    }
  });
})();
